import React, { Component } from 'react'
import _ from 'underscore'
import { createAvatarElement } from '../../utils'

export default class Avatar extends Component {
    render() {
        const { className } = this.props;
        let props = _.pick(this.props, "width", "height", "src", "text");

        return (
            <div className={className}>
		        {createAvatarElement(props)}
		        {props.text}
        	</div>
        )

    }
}


// WEBPACK FOOTER //
// ./src/ui/avatar/normal.js